import type { CriteriaForm } from '@niarab2c/niarab2c-core/src/app/base';
import { formatDate } from '@niaratech/niara-js-commons';
import React from 'react';
import { diffInDays } from '@niaratech/niara-js-commons/dist/dateUtils';
import DateCheck from '../../../components/DateCheck';
import * as S from './styles';
export type StickyCartTitleProps = {
  criteria: CriteriaForm;
};
const StickyCartTitle: React.FC<StickyCartTitleProps> = ({
  criteria
}) => {
  const nights = diffInDays(criteria?.endDate, criteria?.startDate) || 1;
  const totalGuests = criteria?.rooms?.reduce((total, room) => ({
    adults: total?.adults + (room?.adults || 0),
    children: total?.children + (room?.children || 0)
  }), {
    adults: 0,
    children: 0
  });
  const numberOfGuests = totalGuests?.adults + totalGuests?.children;
  return <S.CartTitle>
      <S.CartName>{criteria?.destinationName}</S.CartName>

      <S.HeaderData>
        <DateCheck withTitle startDate={formatDate(criteria?.startDate, undefined, 'dd MMM yy')} endDate={formatDate(criteria?.endDate, undefined, 'dd MMM yy')} />

        <div>
          <S.Label>Noites</S.Label>
          <S.Text>{nights}</S.Text>
        </div>

        <div>
          <S.Label>Hóspedes</S.Label>
          <S.Text>{numberOfGuests}</S.Text>
        </div>
      </S.HeaderData>
    </S.CartTitle>;
};
export default StickyCartTitle;